import { useCallback, useState } from 'react'

import { Button, DefaultTooltip } from 'twyne-new.ui'

import { useAppAlert } from '@Components/AppAlert'

import { useCustomReportStore } from '../store'

export default function SaveReportViewButton() {
  const { handleSuccess, handleError } = useAppAlert()
  const {
    activeView: { id, isDefault, save },
    report: { isLoading },
  } = useCustomReportStore()
  const [saving, setSaving] = useState(false)

  const handleSave = useCallback(async () => {
    if (!id || isDefault) return

    setSaving(true)
    try {
      await save()
      handleSuccess('Success', 'Report saved.')
    } catch {
      handleError('Error', 'Report was not saved.')
    } finally {
      setSaving(false)
    }
  }, [id, isDefault, save, handleSuccess, handleError])

  return (
    <DefaultTooltip
      content={isDefault && 'Default reports cannot be saved'}
      triggerProps={{ asChild: true }}
    >
      <Button
        size="lg"
        variant="outline"
        disabled={!id || isDefault || saving || isLoading}
        onClick={handleSave}
      >
        Save
      </Button>
    </DefaultTooltip>
  )
}
